import { useState } from 'react'
import Box from '@mui/joy/Box'
import Typography from '@mui/joy/Typography'
import { Wizard } from '../components/Wizard'
import { VideoCampaignForm } from '../components/VideoCampaignForm'
import { VideoCampaignUploader } from '../components/VideoCampaignUploader'

const CampaignFormStep = ({ onSubmit }) => (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
        <Typography level="h2" color="neutral">
            Create Video Campaign
        </Typography>
        <VideoCampaignForm onSubmit={onSubmit} />
    </Box>
)

const UploadStep = ({ onStatusChanged }) => (
    <Box sx={{ display: 'flex', justifyContent: 'center' }}>
        <VideoCampaignUploader onStatusChanged={onStatusChanged} />
    </Box>
)

export const VideoCampaign = () => {
    const [isComplete, setIsComplete] = useState(false)

    const steps = [
        {
            component: <CampaignFormStep />,
            stepFunc: {
                name: 'onSubmit',
            },
        },
        {
            component: <UploadStep />,
            stepFunc: {
                name: 'onStatusChanged',
            },
        },
    ]

    const handleStepChange = (currentStep) => {
        if (currentStep === steps.length) {
            setIsComplete(true)
        }
    }

    return isComplete ? (
        <Box sx={{ display: 'flex', justifyContent: 'center' }}>
            <Typography level="h3" color="neutral">
                We're creating your video campaign! 🥳 You'll get an email when
                it's ready.
            </Typography>
        </Box>
    ) : (
        <Wizard steps={steps} onStepChange={handleStepChange} />
    )
}
